export default __webpack_public_path__ + "294dbf253d67bf333bda7fd0de766295.svg";